import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-AimingShape",
  "use": "svg-icon-AimingShape-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-AimingShape\"><rect fill=\"none\" height=\"100%\" width=\"100%\" /><path d=\"M6.5.5a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm0 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z\" /><path d=\"M6.5 3.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol